import OrderManagementRepositoryImpl from './impl/OrderManagementRepositoryImpl'

export default {
  getInstance () {
    return new OrderManagementRepositoryImpl()
  }
}
